<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template v-slot:progress>
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>
      <v-card-text class="pb-0">
        <div class="text-h6 font-weight-black">Graus acadêmicos</div>
      </v-card-text>
      <div class="content-flex">
        <div style="flex: 0.7; height: 100%; position: relative; margin-top: 20px">
          <apexchart height="55%" width="100%" :options="chartOptions" :series="series" />
        </div>
        <div style="flex: 1; padding: 14px; overflow-y: auto; height: 100%">
          <div class="legend-container">
            <div v-for="(label, index) in chartOptions.labels" :key="index" class="legend-item">
              <span class="legend-color" :style="{ backgroundColor: getColor(index) }"></span>
              <span class="legend-text">{{ label }}: {{ series[index] }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "ProfessorGeneroCard",
  mounted() {
    this.getGrauAcademico();
  },
  data() {
    return {
      loading: true,
      series: [],
      colors: ["#008FFB", "#00E396", "#FEB019", "#775DD0", "#FF4560", "#546E7A"],
      chartOptions: {
        chart: {
          type: "donut",
        },
        legend: {
          show: false,
        },
        labels: [
          "Graduados",
          "Doutores",
          "Mestres",
          "Superior Incompleto",
          "Tecnico",
          "Ensino Medio Completo",
        ],
        colors: ["#008FFB", "#00E396", "#FEB019", "#775DD0", "#FF4560", "#546E7A"],
        dataLabels: {
          enabled: true,
        },
        plotOptions: {
          pie: {
            donut: {
              size: "55%",
            },
          },
        },
      },
    };
  },
  methods: {
    getColor(index) {
      return this.colors[index % this.colors.length];
    },

    async getGrauAcademico() {
      const response = await this.$services.professoresService.contagemGrauAcademico();
      const payload = Object.values(response);

      this.loading = false;
      this.series = [];
      this.series.push(parseInt(payload[0], 10));
      this.series.push(parseInt(payload[1], 10));
      this.series.push(parseInt(payload[2], 10));
      this.series.push(parseInt(payload[3], 10));
      this.series.push(parseInt(payload[4], 10));
      this.series.push(parseInt(payload[5], 10));
      // this.series.push(parseInt(payload[6], 10));
      // this.series.push(parseInt(payload[7], 10));
    },
  },
};
</script>

<style scoped>
.legend-container {
  margin-top: 10px;
  max-height: 100px;
  overflow-y: auto;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.legend-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  margin-right: 8px;
}

.legend-text {
  font-size: 0.8rem;
}
.content-flex {
  display: flex;
  height: 100%;
}

/* Ajustes responsivos */
@media (max-width: 600px) {
  div[style*="display: flex"] {
    flex-direction: column;
  }

  .legend-container {
    max-height: none;
  }
}
</style>
